import { c as _c } from "react/compiler-runtime";
import { useIntl } from '@onefootprint/hooks';
import { formatDistanceToNow } from 'date-fns';
const SEVEN_DAYS_MS = 7 * 24 * 60 * 60 * 1000;
const useRelativeTimestamp = createdAt => {
  const $ = _c(3);
  const {
    formatDateWithTime
  } = useIntl();
  let t0;
  if ($[0] !== createdAt || $[1] !== formatDateWithTime) {
    const date = new Date(createdAt);
    const isRecent = Date.now() - date.getTime() < SEVEN_DAYS_MS;
    t0 = isRecent ? formatDistanceToNow(date, {
      addSuffix: true
    }) : formatDateWithTime(date);
    $[0] = createdAt;
    $[1] = formatDateWithTime;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default useRelativeTimestamp;